module.exports = __webpack_public_path__ + "static/FM-8874b515fc493d435f434575e1b09c42.jpg";